module.exports = __webpack_public_path__ + "img/scroll4.bc4c5c84.png";